import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/** Monto acumulado en una moneda concreta. */
export interface MontoPorMoneda {
  moneda: string;
  total: number;
}

/**
 * Totales de un tipo de operacion. `destino` es lo que recibe el
 * beneficiario (USDT / VES / USD / CLP segun el tipo) y `origen` lo que
 * puso el cliente (casi siempre CLP).
 */
export interface TotalesTipo {
  count: number;
  destino: MontoPorMoneda[];
  origen: MontoPorMoneda[];
}

export interface CompletedTotalsDia {
  date: string;
  CRIPTO: TotalesTipo;
  FIAT: TotalesTipo;
  ZELLE: TotalesTipo;
  RETIRO: TotalesTipo;
  AC: TotalesTipo;
  SWAP_USDT_VES: TotalesTipo;
  RETIRO_VES: TotalesTipo;
  /** Remesas a Colombia y Peru por el riel Vita, consolidadas. */
  REMESA_INTL: TotalesTipo;
}

export interface CompletedTotalsResponse {
  currentDay: CompletedTotalsDia;
  previousDay: CompletedTotalsDia;
}

@Injectable({ providedIn: 'root' })
export class OperationsDashboardService {
  private apiUrl = `${environment.apiNest}operations-dashboard`;

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    return new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${localStorage.getItem('token') || ''}`);
  }

  /**
   * Montos completados de hoy y ayer por tipo de operacion y moneda.
   * Los contadores siguen viniendo de `transaccion/completed-count`
   * (wallet-back); este endpoint solo agrega los montos.
   */
  getCompletedTotals(date?: string): Observable<CompletedTotalsResponse> {
    let params = new HttpParams();
    if (date) {
      params = params.set('date', date);
    }
    return this.http.get<CompletedTotalsResponse>(
      `${this.apiUrl}/completed-totals`,
      { headers: this.getHeaders(), params },
    );
  }
}
